import { render, staticRenderFns } from "./rturngoodModifyRemarks.vue?vue&type=template&id=2de40744"
import script from "./rturngoodModifyRemarks.vue?vue&type=script&lang=js"
export * from "./rturngoodModifyRemarks.vue?vue&type=script&lang=js"
import style0 from "./rturngoodModifyRemarks.vue?vue&type=style&index=0&id=2de40744&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports